// extracted by mini-css-extract-plugin
export default {"wrapper":"K0epfFm5hkV8_uCJPAaw","infoWrapper":"qWedDJfiAfrUg4cK9Nhj","extraName":"CVyAokefR3E9IOteBUzU"};